<template>
	<popup v-model="visable" type="bottom" title="选择时间" @close="visable=false">
		<div class="date flex between-v">
			<TimeSwiper @timeChange="timeChange" />
			<div class="btn">
				<button @click="confirm" class="btn-full">确认时间</button>
			</div>
		</div>
	</popup>
</template>

<script>
// import SelectTime from "@manage/components/picker/time.vue";
// <SelectTime ref="pickstatus" @confirm="1"/>
import TimeSwiper from "../child/timeSwiper.vue";
export default {
	name: "term",
	components: {
		TimeSwiper,
	},
	data() {
		return {
			visable: false,
			time: "00:00:00",
		};
	},
	methods: {
		show() {
			this.visable = true;
		},
		confirm() {
			this.visable = false;
			this.$emit('confirm',this.time)
		},
		timeChange(e) {
			this.time = e;
		},
	},
};
</script>

<style lang="less" scoped>
.date {
	padding: 10 / @rem 0 20 / @rem;
	.list {
		.item {
			font-size: 16px;
			height: 48 / @rem;
			color: rgba(31, 30, 29, 0.7);
			&:active {
				color: #ffa216;
			}
		}
		.active {
			color: #ffa216;
		}
	}
	.btn {
		width: 100%;
		padding: 0 17 / @rem;
		.btn-full {
			margin-top: 10 / @rem;
		}
	}
}
</style>